<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-button class="btn-round"
                          :variant="(isOpenFormAddNew ? 'danger' : 'primary')"
                          @click="showAndHideForm">
                    {{ (isOpenFormAddNew ? "close" : "+ Add gift")}}
                </b-button>
            </template>
        </navbar>
        <!--END Navbar-->

        <b-card title="Add" v-if="isOpenFormAddNew">
            <template>
                <b-form-group
                        class="required"
                        label="title">
                    <b-input v-model="form.title"></b-input>
                </b-form-group>
                <b-form-group
                        class="required"
                        label="score">
                    <b-input type="number" v-model="form.score"></b-input>
                </b-form-group>
                <b-form-group
                        class="required"
                        label="image">
                    <template v-if="previewUrl !== null">
                        <b-img width="120" :src="previewUrl" alt=""></b-img>
                    </template>

                    <b-form-file v-model="form.image" @change="onSelectFile"></b-form-file>
                </b-form-group>
                <b-form-group
                        class="required"
                        label="products">
                    <v-select
                            placeholder="select"
                            multiple
                            :reduce="product_title => product_title.product_id"
                            label="product_title"
                            v-model="form.products"
                            :options="products"></v-select>
                </b-form-group>
                <b-form-group
                        label="is free?">
                    <b-form-checkbox v-model="form.free_gift">is free?</b-form-checkbox>
                </b-form-group>
                <br>
                <br>


                <template v-if="editedItemId > 0">
                    <b-button @click="updateGift" variant="success">save</b-button>
                </template>

                <template v-else>
                    <b-button @click="storeGift" variant="success">save</b-button>
                </template>

            </template>

        </b-card>
        <!--END Form-->
        <template v-if="itemsFree.length > 0">
            <h2>Geschenk Free: {{itemsFree.length}}</h2>
            <b-card v-for="(item,index) in itemsFree"
                    :key="index">
                <b-media>
                    <template #aside>
                        <b-img :src="item.image_url" width="64" alt="placeholder"></b-img>
                    </template>

                    <h5 class="mt-0">{{item.title}}</h5>
                    <p>score : <span class="font-weight-bold">{{item.score}}</span></p>
                    <p>
                        <span class="mr-3" v-for="(item,index) in item.products"
                              :key="index">{{item.product_title}}</span>
                    </p>
                    <p class="mb-0">
                        <span class="ml-4 text-primary">
                            <a @click.prevent="editItem(item)" href="#">
                                <span class="material-icons">edit</span>
                            </a>
                            <a class="text-danger ml-3"
                               @click.prevent="deleteGift(item.id)"
                               href="#">
                                <span class="material-icons">delete</span>
                            </a>
                        </span>
                    </p>
                    <p class="text-right font-weight-bold" style="font-size: 24px">{{++index}}</p>
                </b-media>
            </b-card>

        </template>
        <!--gifts free-->


        <h2>Geschenk: {{items.length}}</h2>

        <template v-if="items.length > 0">
            <draggable v-model="items" group="items"
                       @update="updateOrder"
                       @start="drag=true"
                       handle=".handle"
                       @end="drag=false">
                <b-card v-for="(item,index) in items"
                        :key="index">
                    <b-media>
                        <template #aside>
                            <b-img :src="item.image_url" width="64" alt="placeholder"></b-img>
                        </template>

                        <h5 class="mt-0">{{item.title}}</h5>
                        <p>score : <span class="font-weight-bold">{{item.score}}</span></p>
                        <p>
                            <span class="mr-3" v-for="(item,index) in item.products"
                                  :key="index">{{item.product_title}}</span>
                        </p>
                        <p class="mb-0">
                        <span class="ml-4 text-primary">
                            <a @click.prevent="editItem(item)" href="#">
                                <span class="material-icons">edit</span>
                            </a>
                            <a class="text-danger ml-3"
                               @click.prevent="deleteGift(item.id)"
                               href="#">
                                <span class="material-icons">delete</span>
                            </a>
                        </span>
                        </p>
                        <p class="text-right font-weight-bold" style="font-size: 24px">
                            <span class="mr-3 handle">
                                <span class="material-icons">drag_handle</span>
                            </span>
                            <span>{{++index}}</span>
                        </p>
                    </b-media>
                </b-card>
            </draggable>

        </template>
        <!--gifts-->

    </div>
</template>

<script>

    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notificaion from '../../Services/Notification/Nottification'
    import draggable from 'vuedraggable'


    export default {
        name: "Index",
        components: {
            Navbar,
            draggable
        },
        data() {
            return {
                isOpenFormAddNew: false,
                dictionary: null,
                previewUrl: null,
                products: [],
                items: [],
                itemsFree: [],
                form: {
                    title: null,
                    score: null,
                    free_gift: false,
                    products: [],
                    image: null,
                },
                editedItemId: null,
            }
        },
        methods: {
            updateOrder() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'gift/order/items/process', {
                    items: this.items
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.getItems();
                            Notificaion.success(response.data.message)
                        } else {
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            onSelectFile(event) {
                this.previewUrl = URL.createObjectURL(event.target.files[0]);
            },
            showAndHideForm() {
                this.isOpenFormAddNew = !this.isOpenFormAddNew;

                if (!this.isOpenFormAddNew) {
                    this.editedItemId = 0;
                }
            },
            editItem(myItem) {
                window.scrollTo(0, 0);
                this.isOpenFormAddNew = true;
                this.editedItemId = myItem.id;
                this.form.title = myItem.title;
                this.form.score = myItem.score;
                this.form.products = myItem.productsIds;
            },
            storeGift() {

                if (this.form.title === null) {
                    Notificaion.error("please enter title");
                    return;
                }

                if (this.form.score === null) {
                    Notificaion.error("please enter score");
                    return;
                }

                if (this.form.image === null) {
                    Notificaion.error("please select image");
                    return;
                }

                if (this.form.products.length === 0) {
                    Notificaion.error("please select products");
                    return;
                }

                this.$Progress.start();

                let fd = new FormData();
                fd.append("title", this.form.title);
                fd.append("score", this.form.score);
                fd.append("free_gift", this.form.free_gift);
                fd.append("products", JSON.stringify(this.form.products));
                fd.append("image", this.form.image);

                Http.post(Http.apiurlV2() + 'gift/store', fd)
                    .then(response => {
                        if (response.data.status_code === Http.created()) {
                            this.$Progress.finish();
                            this.editedItemId = 0;
                            this.form.title = null;
                            this.form.score = null;
                            this.form.products = [];
                            this.form.image = null;
                            this.previewUrl = null;
                            this.isOpenFormAddNew = false;
                            this.getItems();
                            Notificaion.success(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getItems() {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'gift/index')
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.items = response.data.data.gifts;
                            this.itemsFree = response.data.data.giftsFree;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },

            getProducts() {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'gift/products')
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.products = response.data.data;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },

            updateGift() {

                if (this.form.title === null || this.form.title.length == 0) {
                    Notificaion.error("please enter title");
                    return;
                }

                if (this.form.score === null || this.form.score.length == 0) {
                    Notificaion.error("please enter score");
                    return;
                }

                if (this.form.products.length === 0) {
                    Notificaion.error("please select products");
                    return;
                }

                this.$Progress.start();



                let fd = new FormData();
                fd.append("title", this.form.title);
                fd.append("score", this.form.score);
                fd.append("free_gift", this.form.free_gift);
                fd.append("products", JSON.stringify(this.form.products));
                if (this.form.image !== null) {
                    fd.append("image", this.form.image);
                }

                Http.post(Http.apiurlV2() + 'gift/update/' + this.editedItemId, fd)
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.getItems();
                            this.editedItemId = 0;
                            this.form.title = null;
                            this.form.score = null;
                            this.form.products = [];
                            this.form.image = null;
                            this.form.previewUrl = null;
                            this.isOpenFormAddNew = false;
                            Notificaion.success(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            deleteGift(id) {
                if (confirm("Are you sure delete this item ?")) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'gift/delete/' + id)
                        .then(response => {
                            if (response.data.status_code === Http.ok()) {
                                this.$Progress.finish();
                                this.getItems();
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
        },
        created() {
            this.getItems();
            this.getProducts();
        }

    }
</script>

<style scoped>

</style>